var LangSelect = $.extend({/* LangSelect */}, BaseComponent, {

	componentSelector: '.lang-select',

	init: function() {
		device.mobile() ? this.initMobileLangSelects() : this.initLangSelects();
	},

	initMobileLangSelects: function() {

		$(this.componentSelector).each((function (index, element) {

			$(element).find('.menu-mobile-trigger').click((function(event) {
				$(event.currentTarget).siblings('.menu-mobile-dropdown').slideToggle(500);

				if ($(event.currentTarget).find('i').hasClass('icon-flecha_circulo_down')) {
					$(event.currentTarget).find('i').removeClass('icon-flecha_circulo_down');
					$(event.currentTarget).find('i').addClass('icon-flecha_circulo_up');
				}
				else if ($(event.currentTarget).find('i').hasClass('icon-flecha_circulo_up')) {
					$(event.currentTarget).find('i').removeClass('icon-flecha_circulo_up');
					$(event.currentTarget).find('i').addClass('icon-flecha_circulo_down');
				}
			}).bind(this));

			$(element).find('.menu-mobile-dropdown li').click((function(event) {
				event.stopPropagation();
				$(event.currentTarget).parents('.menu-mobile-dropdown').slideToggle(500);
				this.changeLanguage($(event.currentTarget).find('a').attr('lng-code'));
			}).bind(this));

		}).bind(this));
	},

	initLangSelects: function() {

		$(this.componentSelector).each((function (index, element) {

			if (device.desktop()) {

				$(element).mouseenter((function(event) {
					$(event.currentTarget).addClass('active');
				}).bind(this));

				$(element).mouseleave((function(event) {
					$(event.currentTarget).removeClass('active');
				}).bind(this));

			} else {

				$(element).click((function(event) {
					$(event.currentTarget).toggleClass('active');
				}).bind(this));
			}

			$(element).find('.drop-menu li').click((function(event) {
				event.stopPropagation();
				var optionValue = $(event.currentTarget).find('a').attr('data-lang');
				$(event.currentTarget).parents('.dropdown-header-cell').find('.lang-selected').text(optionValue);
				$(event.currentTarget).parents(this.componentSelector).removeClass('active');
				this.changeLanguage($(event.currentTarget).find('a').attr('lng-code'));
			}).bind(this));

		}).bind(this));
	},

	changeLanguage: function(lng) {
		var prev = Language.getLanguage();
		Language.setLanguage(lng);
		Language.translatePage(prev);
	}
})